export default "__VITE_ASSET__DrqSrhc3__"